

import * as React from "react";

const TopLight = ({configuration,sidelightColour}) => {


    if (configuration === "e" || configuration === "f") {
        return <svg
            width={1370}
            height={1878}
            viewBox="0 0 1370 1878"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            x={`${configuration === 'e' ?  '-170' : '140'} ` }
            y='-80'
        >
            <g clipPath="url(#clip0_5_91)">
                <mask
                    id="mask0_5_91"
                    style={{
                        maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={1370}
                    height={1878}
                >
                    <path d="M1370 0H0V1878H1370V0Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_5_91)">
                    <path
                        d="M1327.77 44.267H42.2417V259.384H1327.77V44.267Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1326.81 45.3409H43.2491V258.327H1326.81V45.3409Z"
                        fill='#D0DCEA'
                    />
                    <path
                        d="M42.2921 44.393H43.7001L1.46419 0H0.0561319H0V1.539L42.2921 45.932V44.393Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1327.76 259.688H1326.41L1368.65 304.081H1370V302.542L1327.76 258.208V259.688Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1327.76 258.208L1370 302.542V1.53894L1327.76 45.9319V258.208Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1342.13 273.302V30.8391L1366.23 5.56409V298.576L1342.13 273.302Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1368.65 0L1326.41 44.393H1327.76V45.932L1370 1.539V0H1368.65Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M42.2351 45.9319L0 1.53894V302.542L42.2351 258.149V45.9319Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M27.8757 30.779V273.302L3.77319 298.576V5.505L27.8757 30.779Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1.46419 304.081L43.5869 259.747H42.235V258.149L0 302.542V304.081H1.46419Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1326.46 44.393L1368.65 0H1.46411L43.643 44.393H1326.46Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1340.83 29.2999H29.2828L5.23743 3.96594H1364.87L1340.83 29.2999Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1326.46 259.747L1368.65 304.081H1.46411L43.643 259.747H1326.46Z"
                        fill={sidelightColour}
                    />
                    <path
                        d="M1340.83 274.841H29.2828L5.23743 300.115H1364.87L1340.83 274.841Z"
                        fill={sidelightColour}
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_5_91"
                    x1={1327.76}
                    y1={152.04}
                    x2={1370}
                    y2={152.04}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.036} stopColor="#D2D4D5"/>
                    <stop offset={0.043} stopColor="#D5D7D8"/>
                    <stop offset={0.096} stopColor="#E6E7E7"/>
                    <stop offset={0.161} stopColor="#F1F2F2"/>
                    <stop offset={0.254} stopColor="#F8F8F8"/>
                    <stop offset={0.51} stopColor="#FAFAFA"/>
                    <stop offset={0.778} stopColor="#F8F8F8"/>
                    <stop offset={0.874} stopColor="#F1F2F2"/>
                    <stop offset={0.943} stopColor="#E6E7E7"/>
                    <stop offset={0.998} stopColor="#D5D7D7"/>
                    <stop offset={1} stopColor="#D4D6D6"/>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_5_91"
                    x1={42.236}
                    y1={152.041}
                    x2={0}
                    y2={152.041}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.036} stopColor="#D2D4D5"/>
                    <stop offset={0.043} stopColor="#D5D7D8"/>
                    <stop offset={0.096} stopColor="#E6E7E7"/>
                    <stop offset={0.161} stopColor="#F1F2F2"/>
                    <stop offset={0.254} stopColor="#F8F8F8"/>
                    <stop offset={0.51} stopColor="#FAFAFA"/>
                    <stop offset={0.778} stopColor="#F8F8F8"/>
                    <stop offset={0.874} stopColor="#F1F2F2"/>
                    <stop offset={0.943} stopColor="#E6E7E7"/>
                    <stop offset={0.998} stopColor="#D5D7D7"/>
                    <stop offset={1} stopColor="#D4D6D6"/>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_5_91"
                    x1={685.056}
                    y1={44.394}
                    x2={685.056}
                    y2={0}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.036} stopColor="#D2D4D5"/>
                    <stop offset={0.043} stopColor="#D5D7D8"/>
                    <stop offset={0.096} stopColor="#E6E7E7"/>
                    <stop offset={0.161} stopColor="#F1F2F2"/>
                    <stop offset={0.254} stopColor="#F8F8F8"/>
                    <stop offset={0.51} stopColor="#FAFAFA"/>
                    <stop offset={0.778} stopColor="#F8F8F8"/>
                    <stop offset={0.874} stopColor="#F1F2F2"/>
                    <stop offset={0.943} stopColor="#E6E7E7"/>
                    <stop offset={0.998} stopColor="#D5D7D7"/>
                    <stop offset={1} stopColor="#D4D6D6"/>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_5_91"
                    x1={685.056}
                    y1={259.747}
                    x2={685.056}
                    y2={304.082}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.036} stopColor="#D2D4D5"/>
                    <stop offset={0.043} stopColor="#D5D7D8"/>
                    <stop offset={0.096} stopColor="#E6E7E7"/>
                    <stop offset={0.161} stopColor="#F1F2F2"/>
                    <stop offset={0.254} stopColor="#F8F8F8"/>
                    <stop offset={0.51} stopColor="#FAFAFA"/>
                    <stop offset={0.778} stopColor="#F8F8F8"/>
                    <stop offset={0.874} stopColor="#F1F2F2"/>
                    <stop offset={0.943} stopColor="#E6E7E7"/>
                    <stop offset={0.998} stopColor="#D5D7D7"/>
                    <stop offset={1} stopColor="#D4D6D6"/>
                </linearGradient>
                <clipPath id="clip0_5_91">
                    <rect width={1370} height={1878} fill="white"/>
                </clipPath>
            </defs>
        </svg>
    }

  return  <svg
        width={1670}
        height={1878}
        viewBox="0 0 1670 1878"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        x='-170'
        y='-80'
    >
        <g clipPath="url(#clip0_4_70)">
            <path
                d="M1618.52 44.267H51.4917V259.384H1618.52V44.267Z"
                fill={sidelightColour}
            />
            <path
                d="M1617.35 45.3409H52.7197V258.327H1617.35V45.3409Z"
                fill='#D0DCEA'
            />
            <path
                d="M51.5532 44.393H53.2695L1.78482 0H0.0684236H0V1.539L51.5532 45.932V44.393Z"
                fill={sidelightColour}
            />
            <path
                d="M1618.51 259.688H1616.87L1668.36 304.081H1670V302.542L1618.51 258.208V259.688Z"
                fill={sidelightColour}
            />
            <path
                d="M1618.51 258.208L1670 302.542V1.53894L1618.51 45.9319V258.208Z"
                fill={sidelightColour}
            />
            <path
                d="M1636.03 273.302V30.8391L1665.4 5.56409V298.576L1636.03 273.302Z"
                fill={sidelightColour}
            />
            <path
                d="M1668.36 0L1616.87 44.393H1618.51V45.932L1670 1.539V0H1668.36Z"
                fill={sidelightColour}
            />
            <path
                d="M51.4836 45.9319L0 1.53894V302.542L51.4836 258.149V45.9319Z"
                fill={sidelightColour}
            />
            <path
                d="M33.9799 30.779V273.302L4.59949 298.576V5.505L33.9799 30.779Z"
                fill={sidelightColour}
            />
            <path
                d="M1.78482 304.081L53.1315 259.747H51.4836V258.149L0 302.542V304.081H1.78482Z"
                fill={sidelightColour}
            />
            <path
                d="M1616.93 44.393L1668.36 0H1.78479L53.1999 44.393H1616.93Z"
                fill={sidelightColour}
            />
            <path
                d="M1634.44 29.2999H35.6951L6.38428 3.96594H1663.75L1634.44 29.2999Z"
                fill={sidelightColour}
            />
            <path
                d="M1616.93 259.747L1668.36 304.081H1.78479L53.1999 259.747H1616.93Z"
                fill={sidelightColour}
            />
            <path
                d="M1634.44 274.841H35.6951L6.38428 300.115H1663.75L1634.44 274.841Z"
                fill={sidelightColour}
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_4_70"
                x1={1618.51}
                y1={152.04}
                x2={1670}
                y2={152.04}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.036} stopColor="#D2D4D5"/>
                <stop offset={0.043} stopColor="#D5D7D8"/>
                <stop offset={0.096} stopColor="#E6E7E7"/>
                <stop offset={0.161} stopColor="#F1F2F2"/>
                <stop offset={0.254} stopColor="#F8F8F8"/>
                <stop offset={0.51} stopColor="#FAFAFA"/>
                <stop offset={0.778} stopColor="#F8F8F8"/>
                <stop offset={0.874} stopColor="#F1F2F2"/>
                <stop offset={0.943} stopColor="#E6E7E7"/>
                <stop offset={0.998} stopColor="#D5D7D7"/>
                <stop offset={1} stopColor="#D4D6D6"/>
            </linearGradient>
            <linearGradient
                id="paint1_linear_4_70"
                x1={51.4848}
                y1={152.041}
                x2={0}
                y2={152.041}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.036} stopColor="#D2D4D5"/>
                <stop offset={0.043} stopColor="#D5D7D8"/>
                <stop offset={0.096} stopColor="#E6E7E7"/>
                <stop offset={0.161} stopColor="#F1F2F2"/>
                <stop offset={0.254} stopColor="#F8F8F8"/>
                <stop offset={0.51} stopColor="#FAFAFA"/>
                <stop offset={0.778} stopColor="#F8F8F8"/>
                <stop offset={0.874} stopColor="#F1F2F2"/>
                <stop offset={0.943} stopColor="#E6E7E7"/>
                <stop offset={0.998} stopColor="#D5D7D7"/>
                <stop offset={1} stopColor="#D4D6D6"/>
            </linearGradient>
            <linearGradient
                id="paint2_linear_4_70"
                x1={835.068}
                y1={44.394}
                x2={835.068}
                y2={0}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.036} stopColor="#D2D4D5"/>
                <stop offset={0.043} stopColor="#D5D7D8"/>
                <stop offset={0.096} stopColor="#E6E7E7"/>
                <stop offset={0.161} stopColor="#F1F2F2"/>
                <stop offset={0.254} stopColor="#F8F8F8"/>
                <stop offset={0.51} stopColor="#FAFAFA"/>
                <stop offset={0.778} stopColor="#F8F8F8"/>
                <stop offset={0.874} stopColor="#F1F2F2"/>
                <stop offset={0.943} stopColor="#E6E7E7"/>
                <stop offset={0.998} stopColor="#D5D7D7"/>
                <stop offset={1} stopColor="#D4D6D6"/>
            </linearGradient>
            <linearGradient
                id="paint3_linear_4_70"
                x1={835.068}
                y1={259.747}
                x2={835.068}
                y2={304.082}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.036} stopColor="#D2D4D5"/>
                <stop offset={0.043} stopColor="#D5D7D8"/>
                <stop offset={0.096} stopColor="#E6E7E7"/>
                <stop offset={0.161} stopColor="#F1F2F2"/>
                <stop offset={0.254} stopColor="#F8F8F8"/>
                <stop offset={0.51} stopColor="#FAFAFA"/>
                <stop offset={0.778} stopColor="#F8F8F8"/>
                <stop offset={0.874} stopColor="#F1F2F2"/>
                <stop offset={0.943} stopColor="#E6E7E7"/>
                <stop offset={0.998} stopColor="#D5D7D7"/>
                <stop offset={1} stopColor="#D4D6D6"/>
            </linearGradient>
            <clipPath id="clip0_4_70">
                <rect width={1670} height={1878} fill="white"/>
            </clipPath>
        </defs>
    </svg>
};


export default TopLight;
